import {
  bool, string, number, customType, id
} from '@thd-nucleus/data-sources';

export const authParams = {
  channelId: number().isRequired(),
  customerAccountId: string().isRequired(),
  userId: string().isRequired(),
};

export const authParamsV2 = {
  channelId: number().isRequired(),
  customerAccountId: id().isRequired(),
  userId: id().isRequired(),
};

export const authParamsV2Challenges = {
  channelId: number().isRequired(),
  customerAccountId: id().isRequired(),
  userId: id().isRequired(),
  challengeType: string(),
};

export const acceptChallengeParams = {
  ...authParamsV2,
  challengeInput: customType('V2ChallengeInput').shape({
    id: id().isRequired(),
    customerChallengeId: id(),
    isV2: bool(),
    stepId: id(),
    status: string(),
  }).isRequired(),
};

export const activatePerkParams = {
  ...authParamsV2,
  perkInput: customType('V2PerkInput').shape({
    perkId: string().isRequired(),
    tierRewardId: string().isRequired(),
    userId: string().isRequired(),
    programId: string().isRequired(),
    tierId: string().isRequired(),
  }).isRequired(),
};

export const infoPerksParams = {
  custAccountId: string().isRequired(),
  userId: string().isRequired(),
  offerType: string().isRequired(),
};

export const redeemPerkParams = {
  ...authParamsV2,
  perkInput: customType('V2PerkInput').shape({
    perkId: string().isRequired(),
    paymentId: string().isRequired(),
    omniPaymentId: string(),
    perkSourceUUID: string().isRequired(),
  }).isRequired(),
};
